import { TeamCreditsService } from './../_services/team-credits.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../_services/global.service';
import * as moment from 'moment';

@Component({
  selector: 'app-teaminvite',
  templateUrl: './teaminvite.component.html',
  styleUrls: ['./teaminvite.component.scss']
})
export class TeaminviteComponent implements OnInit {
  admin_emailid: any;
  admin_name: any;
  expiry_time: any;
  errorMessage: any;
  invalidurl: boolean = false;

  constructor(private Route : ActivatedRoute , private teamservice : TeamCreditsService,private router : Router) { }

  ngOnInit() {
    this.Route.queryParams.subscribe(params => {
      this.admin_emailid =   GlobalService.decryptData(params['tokense']);
      this.admin_name =   GlobalService.decryptData(params['tokenun']);
      this.expiry_time =   GlobalService.decryptData(params['tokenv']);
    });

    let start = moment(this.expiry_time);
    let end = moment(new Date());
    let duration = moment.duration(start.diff(end));
    let hours = duration.asHours();
    if(hours > 8){
      this.invalidurl = true
      this.errorMessage =  'Link has expired'
      setTimeout(() => {
        this.errorMessage = ''
        this.router.navigateByUrl('/searchtoolbox-v2')
      }, 5000);
    }
  }
  acceptApplication(type){
    if(!this.invalidurl){
    let data ={
      teamadminemailid : this.admin_emailid,
      invitestatus : type
    }
    this.teamservice.inviteresponse(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.router.navigateByUrl('/subscription/usage')
      }else{
        this.errorMessage =  res.err
        setTimeout(() => {
          this.errorMessage = ''
          this.router.navigateByUrl('/searchtoolbox-v2')
        }, 5000);
      }
    })
  }
}
}
